
import axios from 'axios';
import axiosRetry from 'axios-retry'
import errorHandler from './error-handler'
import storage from '@/utils/storage-service'

const instance = axios.create({
  timeout: 60000
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.put['Content-Type'] = 'application/json'

// 当请求失败后，自动重新请求，只有3次失败后才真正失败
axiosRetry(instance, { retries: 3 })

// 添加请求拦截器
instance.interceptors.request.use(
    config => 
    {
        return config
    }, 
    error => {
        // 请求错误处理
        return Promise.reject(error)
    }
)
  
// 添加响应拦截器
instance.interceptors.response.use(
    response => 
    {
        if(response) {
            let { data } = response
            return data
        }
        else{
            return null
        }
    }, 
    error => {
        let errorInfo = {}
        console.log(error.response)
        if(error.response) {
            let data = error.response.data
            if(data.status == '401') {
                // errorInfo = getErrorInfo(401, "身份已过期，请重新登录！")
                location.href = '/login-auth';
            }
            else{
                errorInfo = getErrorInfo(data.status, data.message)
                errorHandler.ExceptionHandler(errorInfo)
            }
        }
        else {
            errorInfo = getErrorInfo(500, 'Network Error')
            errorHandler.ExceptionHandler(errorInfo)
        }
        return null
    }
)

function getErrorInfo(code, msg) {
    return {
        code: code,
        msg: msg,

    }
}

/**
 * get 请求
 * @param {*} url 
 * @param {*} parameters 
 */
const get = function(url) {
    let options = {}
    options.headers = getHeader()
    return instance.get(url, options)
}

/**
 * post 请求
 * @param {} url 
 * @param {*} parameters 
 */
const post = function(url, parameters) {
    let options = {}
    options.headers = getHeader()
    return instance.post(url, parameters, options)
}

/**
 * put 请求
 * @param {} url 
 * @param {*} parameters 
 */
const put = function(url, parameters) {
    let options = {}
    options.headers = getHeader()
    return instance.put(url, parameters, options)

}

/**
 * delete 请求
 * @param {*} url 
 * @param {*} parameters 
 * @returns 
 */
const remove = function(url) {
    let options = {}
    options.headers = getHeader()
    return instance.delete(url, options)
}

/**
 * upload 上传文件
 * @param {*} url 
 * @param {*} parameters 
 * @returns 
 */ 
const upload = function(url, file, parameters = null) {
    if(!file) return ;
    if(!parameters) {
        let param = new FormData()       // 创建form对象     
        param.append('file', file)       // 通过append向form对象添加数据
        parameters = param
    }
    let options = {}
    options.headers = getHeader(true)
    return instance.post(url, parameters, options)
}

/**
 * 获取动态请求头
 * @returns 
 */
const getHeader = function(isUpload = false) {
    let token = storage.get('token')
    var header = {
        "Accept":"application/json",
        'content-type': 'application/json',
        // "range": 'bytes=0-1',
    }
    if(isUpload) {
        header['Content-Type'] = 'multipart/form-data'
    }
    if(token) {
        header["Authorization"] = 'Bearer '+token
    }
    return header
}

export default {
    get: get,
    post: post,
    put: put,
    delete: remove,
    upload: upload
}